<template>
  <div class="gs-portal-home">
    <section v-if="showElements" class="gs-portal-home__intro">
      <walkthrough-video :source="videoSource" />
      <div class="gs-portal-home__intro-copy">
        <h2 class="gs-portal-home__intro-title">Start here</h2>
        <p class="gs-portal-home__intro-text">
          Watch the quick walkthrough, copy your affiliate link, then pick the promo
          material you want to send.
        </p>
      </div>
    </section>

    <div class="gs-portal-home__grid">
      <button
        v-for="section in sections"
        :key="section.value"
        type="button"
        class="gs-portal-tile"
        :data-section="section.value"
        @click="openSection(section.value)"
      >
        <span class="gs-portal-tile__icon">
          <gs-icon :name="section.icon" size="20" />
        </span>
        <span class="gs-portal-tile__label">{{ section.label }}</span>
        <span v-if="section.completed" class="gs-portal-tile__done">
          <gs-icon name="check" size="14" />
          Done
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { portalSections } from '@/components/promotools/portalSections';
import WalkthroughVideo from '@/components/promotools/WalkthroughVideo.vue';

export default {
  components: { WalkthroughVideo },
  props: {
    assetsTabs: {
      type: Array,
      default: () => [],
    },
    funnelResource: {
      type: Object,
      default: () => {},
    },
    showElements: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sections() {
      return portalSections(this.assetsTabs, this.funnelResource);
    },
    videoSource() {
      if (
        this.funnelResource &&
        this.funnelResource.use_custom_video &&
        this.funnelResource.video_details &&
        this.funnelResource.video_details.id
      ) {
        return this.getVideoSource(this.funnelResource.video_details.service, this.funnelResource.video_details.id);
      }
      return 'https://www.youtube.com/embed/LRfMEiWcV1M?rel=0';
    },
  },
  methods: {
    openSection(value) {
      this.$emit('openPromotoolsSection', value);
    },
    getVideoSource(service, id) {
      switch (service) {
        case 'youtube':
          return `https://www.youtube.com/embed/${id}`;
        case 'vimeo':
          return `https://player.vimeo.com/video/${id}`;
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
.gs-portal-home {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.gs-portal-home__intro {
  display: grid;
  grid-template-columns: minmax(0, 320px) minmax(0, 1fr);
  gap: 20px;
  align-items: center;
  padding: 20px;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-portal-home__intro-copy {
  min-width: 0;
}

.gs-portal-home__intro-title {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.gs-portal-home__intro-text {
  margin: 0 0 14px;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  line-height: 1.5;
}

.gs-portal-home__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.gs-portal-tile {
  display: flex;
  gap: 12px;
  align-items: center;
  min-width: 0;
  padding: 14px 16px;
  color: var(--gs-foreground);
  font: inherit;
  font-size: 15px;
  font-weight: 650;
  text-align: left;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
  cursor: pointer;
  transition: box-shadow 150ms ease, transform 150ms ease, border-color 150ms ease;
}

.gs-portal-tile:hover {
  border-color: var(--gs-primary);
  box-shadow: var(--gs-shadow-md);
  transform: translateY(-1px);
}

.gs-portal-tile:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--gs-ring);
}

.gs-portal-tile__icon {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: var(--gs-primary);
  background: var(--gs-primary-soft);
  border-radius: 999px;
}

.gs-portal-tile__label {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}

.gs-portal-tile__done {
  display: inline-flex;
  flex: none;
  gap: 4px;
  align-items: center;
  color: var(--gs-success);
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 1100px) {
  .gs-portal-home__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 780px) {
  .gs-portal-home__intro {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    padding: 16px;
  }
}

@media (max-width: 560px) {
  .gs-portal-home__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
